export const iconFontAwesomeShapesDiamond = (
	<i className="fa-solid fa-diamond"></i>
);
